var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dynamic-words"},[_c('span',{staticClass:"label"},[_vm._v("插入动态名称:")]),_c('ul',{staticClass:"words-list"},_vm._l((_vm.words),function(word,i){return _c('li',{key:i},[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.appendWord(word)}}},[_vm._v("+"+_vm._s(word))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }